import { CapacitorConfig } from '@capacitor/cli'
import { KeyboardResize } from '@capacitor/keyboard'

const config: CapacitorConfig = {
  appId: 'com.allposit.app',
  appName: 'Allposit',
  webDir: './dist',
  loggingBehavior: typeof process !== 'undefined' && process.env.CI ? 'none' : 'debug',
  backgroundColor: '4438ca',
  server: {
    hostname: 'app.allposit.com',
  },
  ios: {
    contentInset: 'always',
  },
  plugins: {
    CapacitorCookies: {
      enabled: true,
    },
    CapacitorHttp: {
      enabled: true,
    },
    Keyboard: {
      resize: KeyboardResize.Native,
      resizeOnFullScreen: true,
    },
  },
}

export default config
